const FLASH_MS = 1500;
const flashTimers = new Map<string, number>();

export const revealElement = (
  id: string,
  { focusSelector }: { focusSelector?: string } = {}
) => {
  const element = document.getElementById(id);
  if (!element) return;
  element.scrollIntoView({ behavior: "smooth", block: "center" });
  if (focusSelector)
    window.setTimeout(() => {
      element
        .querySelector<HTMLElement>(focusSelector)
        ?.focus({ preventScroll: true });
    }, 0);
  window.clearTimeout(flashTimers.get(id));
  element.removeAttribute("data-flash");
  requestAnimationFrame(() => element.setAttribute("data-flash", ""));
  flashTimers.set(
    id,
    window.setTimeout(() => element.removeAttribute("data-flash"), FLASH_MS)
  );
};
